import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { CarouselItem } from './carousel.interface';


@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent implements OnInit {
  @Input() items: any[] = [];
  @Input() displayCount: number = 1;
  @Input() showShadow: boolean = false;
  @Input() noSpace: boolean = false;
  @Input() controlPaginadorNormal: boolean = true;
  @Input() contentTable: boolean = false;

  currentStartIndex: number = 0;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;

  Math = Math; // Exponer Math para la plantilla

  ngOnInit(): void {
    if (this.displayCount < 1) {
      throw new Error('displayCount debe ser al menos 1.');
    }
  }

  get totalItems(): number {
    return this.items.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  get visibleItems(): any[] {
    return this.items.slice(
      this.currentStartIndex,
      this.currentStartIndex + this.displayCount
    );
  }

  get dots(): number[] {
    return Array.from({ length: Math.ceil(this.items.length / this.displayCount) }, (_, i) => i);
  }

  isActiveDot(index: number): boolean {
    return index === Math.floor(this.currentStartIndex / this.displayCount);
  }

  goToSlide(index: number): void {
    this.currentStartIndex = index * this.displayCount;
  }

  previous(): void {
    if (this.currentStartIndex > 0) {
      this.currentStartIndex -= this.displayCount;
    }
  }

  next(): void {
    if (this.currentStartIndex + this.displayCount < this.items.length) {
      this.currentStartIndex += this.displayCount;
    }
  }
}